import React, { useEffect, useState } from 'react';
import {
    TextField, FormControl, InputLabel, Select, MenuItem, Grid,
    Paper, useMediaQuery, Table, TableBody, TableCell, TableContainer,
    TableHead, TableRow, Button, FormHelperText
} from '@mui/material';
import { Items } from '../TitleList';
import styled, { inputStyles } from '../../Utils/inputChanges';
import Titlebar from '../TitleBar';
import { useDispatch, useSelector } from 'react-redux';
import 'react-toastify/dist/ReactToastify.css';
import { toast, ToastContainer } from 'react-toastify';
import { fetchItemData } from '../../Store/PHPSlice/Item';
import { fetchPannaData } from '../../Store/PHPSlice/Panna';
import { createItemAvgEntry, fetchItemAvgData } from '../../Store/PHPSlice/ItemAvg';
import { errorStyles } from '../../Utils/table';
import { selectItemAvg, selectItems, selectPanna } from '../Selectors/Master/ItemSelectors';
import DropdownWithBtn from '../FieldsComponents/DropdownWithBtn';



const NewItemAvgEntry = () => {
    const userdata = JSON.parse(sessionStorage.getItem('user'));
    const [sizes, setSizes] = useState([]);
    const [pannaValues, setPannaValues] = useState([]);
    const [inputValues, setInputValues] = useState({});
    const [formData, setFormData] = useState({
        itemName: '',
        itemId: '',
        matchingOptions: '',
        numberOfMatching: 0,
        userId: userdata?.ID
    });

    const [openDropdowns, setOpenDropdowns] = useState({});
    const actionMap = {
        itemName: fetchItemData
        // Add more mappings if needed
    };

    const [storedNumberOfMatching, setStoredNumberOfMatching] = useState(0);
    const [storedInputValues, setStoredInputValues] = useState({});
    const [filterName, setFilterName] = useState('null');
    const [currentPage, setCurrentPage] = useState(0);
    const [recordsPerPage, setRecordsPerPage] = useState(10);
    const [errors, setErrors] = useState({});
    const isDesktop = useMediaQuery('(min-width:768px)');
    const dispatch = useDispatch();
    const getItems = useSelector(selectItems);
    const getPana = useSelector(selectPanna);
    const getItemAvg = useSelector(selectItemAvg);
    useEffect(() => {
        dispatch(fetchItemData());
        dispatch(fetchPannaData());
        dispatch(fetchItemAvgData());
        Object.keys(openDropdowns).forEach((dropdown) => {
            if (openDropdowns[dropdown]) {
                const action = actionMap[dropdown];
                if (action) {
                    dispatch(action());
                }
            }
        });
    }, [openDropdowns, dispatch]);

    useEffect(() => {
        if (formData.itemName && getItems && getItems.data.length > 0) {
            const selectedItem = getItems.data.find(item => item.ID === formData.itemName);
            if (selectedItem && selectedItem.size) {
                const sizeArray = typeof selectedItem.size === 'string' ? selectedItem.size.split(',') : selectedItem.size;
                setSizes(sizeArray);
                setFormData(prevState => ({
                    ...prevState,
                    itemId: selectedItem.itemId
                }));
            }
        }
        if (getPana && getPana.data && getPana.data.length > 0) {
            const pannaIds = getPana.data.map(panna => panna.panna_size);
            setPannaValues(pannaIds);
        }
    }, [formData.itemName, getItems, getPana]);

    useEffect(() => {
        if (formData.itemName !== 0 && formData.itemName !== '') {
            // Find the selected item based on its ID
            const selectedItem = getItems.data.find(item => item.ID === formData.itemName);

            if (selectedItem) {
                // Filter the getItemAvg data to find entries related to the selected item
                const relatedData = getItemAvg.data.filter(data => data.itemId === selectedItem.ID);

                if (relatedData.length > 0) {
                    // Initialize input values with related data
                    const initialInputValues = {};
                    let matchingExists = false;
                    let maxMatching = 0;

                    // Populate input values and determine the number of matching fields
                    relatedData.forEach(data => {
                        if (data.avg !== null && data.avg !== '0') {
                            initialInputValues[`${data.size}|${data.panna_size}|Main`] = data.avg;
                        }
                        if (data.avg1 !== null && data.avg1 !== '0') {
                            initialInputValues[`${data.size}|${data.panna_size}|Matching1`] = data.avg1;
                            matchingExists = true;
                            maxMatching = 1; // Set maxMatching to 1 if avg1 is non-zero
                        }
                        if (data.avg2 !== null && data.avg2 !== '0') {
                            initialInputValues[`${data.size}|${data.panna_size}|Matching2`] = data.avg2;
                            matchingExists = true;
                            maxMatching = Math.max(maxMatching, 2); // Update maxMatching to 2 if avg2 is non-zero
                        }
                        if (data.avg3 !== null && data.avg3 !== '0') {
                            initialInputValues[`${data.size}|${data.panna_size}|Matching3`] = data.avg3;
                            matchingExists = true;
                            maxMatching = Math.max(maxMatching, 3); // Update maxMatching to 3 if avg3 is non-zero
                        }
                    });
                    console.log(initialInputValues)
                    setInputValues(initialInputValues);

                    // Update formData with matching options and number of matching fields
                    setFormData(prevState => ({
                        ...prevState,
                        matchingOptions: matchingExists ? 'yes' : 'no',
                        numberOfMatching: maxMatching
                    }));
                } else {
                    // If no related data found, reset matching options and number of matching
                    setFormData(prevState => ({
                        ...prevState,
                        matchingOptions: 'no',
                        numberOfMatching: 0
                    }));
                    setInputValues({}); // Clear input values when no related data found
                }
            }
        }
    }, [formData.itemName, getItems.data, getItemAvg.data]);


    if (!getItems && !getPana && !getItemAvg) {
        return <h1>Loading...</h1>;
    }

    const handleInputChange = (size, panna, value, type = 'Main') => {
        if (value >= 0 || value === '') {
            setInputValues({
                ...inputValues,
                [`${size}|${panna}|${type}`]: value
            });
        }

    };


    const handleDropdownChange = (e, dropdownType) => {
        const { value } = e.target;

        if (dropdownType === 'itemName') {
            // Clear input values when the item name changes
            setInputValues({});
            // Clear stored input values for the current item
            setStoredInputValues(prevState => ({
                ...prevState,
                [formData.itemId]: undefined,
            }));
        } else if (dropdownType === 'matchingOptions') {
            if (value === 'no') {
                const updatedInputValues = { ...inputValues };
                sizes.forEach(size => {
                    pannaValues.forEach(panna => {
                        for (let i = 1; i <= formData.numberOfMatching; i++) {
                            delete updatedInputValues[`${size}|${panna}|Matching${i}`];
                        }
                    });
                });
                setInputValues(updatedInputValues);
            } else {
                // Restore stored number of matching
                setFormData(prevState => ({
                    ...prevState,
                    numberOfMatching: storedNumberOfMatching,
                }));
            }
        }
        setFormData({
            ...formData,
            [dropdownType]: value,
        });
    };




    const handleNumberOfMatchingChange = (e) => {
        const { value } = e.target;
        if (formData.matchingOptions === 'no') {
            setFormData({
                ...formData,
                numberOfMatching: 0  // Clear the value when matching options is 'no'
            });
        } else {
            setFormData({
                ...formData,
                numberOfMatching: parseInt(value)
            });
        }
    };



    const renderMatchingInputs = (size, panna) => {
        const inputs = [];
        for (let i = 1; i <= formData.numberOfMatching; i++) {
            inputs.push(
                <TableCell key={`${size}|${panna}|Matching${i}`} sx={{ p: 1, border: '1px solid #000' }}>
                    <TextField
                        type="text"
                        value={inputValues[`${size}|${panna}|Matching${i}`] || ''}
                        onChange={(e) =>
                            handleInputChange(size, panna, e.target.value, `Matching${i}`)
                        }
                        style={{ width: '40px' }}
                        inputProps={{ style: styled.inputs }}
                        placeholder='0'
                        variant="outlined"
                        size="small"
                    />
                </TableCell>
            );
        }
        return inputs;
    };

    const getPannaValueStructure = () => {
        const pannaStructures = [];
        const pannaMap = {};
        const matchingValues = {};

        if (Array.isArray(sizes) && sizes.length > 0 && getPana && getPana.data) {
            getPana.data.forEach((panna) => {
                sizes.forEach((size) => {
                    const mainValue = inputValues[`${size}|${panna.panna_size}|Main`] || '';
                    const mainFloatValue = mainValue.trim() !== '' ? parseFloat(mainValue) : 0;
                    if (mainFloatValue !== 0) {
                        pannaMap[`${size}|${panna.panna_size}|main`] = mainFloatValue;
                        matchingValues[`${size}|${panna.panna_size}|main`] = mainFloatValue;
                    }

                    if (formData.matchingOptions === 'yes') {
                        for (let i = 1; i <= formData.numberOfMatching; i++) {
                            const matchingValue = inputValues[`${size}|${panna.panna_size}|Matching${i}`] || '';
                            const matchingFloatValue = matchingValue.trim() !== '' ? parseFloat(matchingValue) : 0;
                            if (matchingFloatValue !== 0) {
                                const key = `${size}|${panna.panna_size}|mtch${i}`;
                                pannaMap[key] = matchingFloatValue;
                                matchingValues[key] = matchingFloatValue;
                            }
                        }
                    }
                });

                if (Object.keys(pannaMap).length > 0) {
                    pannaStructures.push({
                        map: pannaMap
                    });
                }
            });
        }

        return matchingValues;
    };

    const structuredPannaValues = getPannaValueStructure();

    const validate = () => {
        const newErrors = {};
        if (!formData.itemName) newErrors.itemName = 'Item Name is required';

        return newErrors;
    };

    const handleSubmit = (event) => {
        event.preventDefault();
        const validationErrors = validate();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }
        const finalObject = {
            itemId: formData.itemName,
            psizeArray: structuredPannaValues,
            userId: formData.userId
        };


        dispatch(createItemAvgEntry(finalObject))
            .unwrap()
            .then((result) => {
                // Handle success
                console.log('POST request successful!', result);
                alert("Item Average Added");
                window.close();
                // You may want to update your component state or perform any other action
            })
            .catch((error) => {
                // Handle error
                console.error('Error while making POST request:', error);
                // You may want to display an error message to the user or perform any other action
            });
    };

    const handleDropdownOpen = (dropdown) => {
        setOpenDropdowns((prev) => ({ ...prev, [dropdown]: true }));
    };

    const handleDropdownClose = (dropdown) => {
        setOpenDropdowns((prev) => ({ ...prev, [dropdown]: false }));
    };

    const handleNavigatePanna = () => {
        window.open(`/new-panna-entry`, '_blank', 'width=800,height=600,scrollbars=yes,resizable=yes');
    };

    const handleNavigateItem = () => {
        window.open(`/NewItemEntry`, '_blank', 'width=800,height=600,scrollbars=yes,resizable=yes');
    };

    const dropdownItem = [
        {
            label: 'Item',
            id: 'itemName',
            options: getItems.data || [],
            value: formData.itemName,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'itemName', value: newValue ? newValue.ID : '' } }, 'itemName'),
            getOptionLabel: (option) => option.itemNm || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },
            handleAddNew: () => handleNavigateItem(),
            btnlabel: 'New',
            handleDropdownOpen: () => handleDropdownOpen('itemName'),
            handleDropdownClose: () => handleDropdownClose('itemName'),
        }
    ];


    return (
        <>
            {/* <Titlebar data={Items} /> */}
            <div style={{ margin: '1%' }}>
                <h2>Item Average Master</h2>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Paper style={{ padding: '3vh', margin: '0' }}>
                            <Grid container spacing={2}>

                                {/* Item Dropdown */}

                                {/* <Grid item xs={12} md={6}>
                                    <Grid container alignItems="center" spacing={1}>
                                        <Grid item style={isDesktop ? { width: '25%' } : { width: '100%' }}>
                                            <InputLabel id="itemName">Item Name:</InputLabel>
                                        </Grid>
                                        <Grid item xs>
                                            <FormControl fullWidth error={!!errors.itemName}>
                                                <Select
                                                    labelId="itemName"
                                                    id="itemName"
                                                    name="itemName"
                                                    value={formData.itemName}
                                                    onChange={(e) => handleDropdownChange(e, 'itemName')}
                                                    sx={inputStyles}
                                                >
                                                    <MenuItem value="">Select an option</MenuItem>
                                                    {getItems && getItems.data.map((item, index) => (
                                                        <MenuItem key={index} value={item.ID}>{item.itemNm}</MenuItem>
                                                    ))}
                                                </Select>
                                                {errors.itemName && <FormHelperText style={errorStyles}>{errors.itemName}</FormHelperText>}
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </Grid> */}

                                {dropdownItem?.map((drop) => (
                                    <DropdownWithBtn
                                        key={drop.label}
                                        label={drop.label}
                                        id={drop.id}
                                        options={drop.options}
                                        value={drop.value}
                                        onChange={drop.onChange}
                                        isDesktop={isDesktop}
                                        getOptionLabel={drop.getOptionLabel}
                                        isOptionEqualToValue={drop.isOptionEqualToValue}
                                        valueFinder={drop.valueFinder}  // Pass `valueFinder` function here
                                        handleAddNew={drop.handleAddNew}
                                        btnlabel={drop.btnlabel}
                                        handleDropdownOpen={drop.handleDropdownOpen}
                                        handleDropdownClose={drop.handleDropdownClose}
                                    />
                                ))
                                }
                                <Grid item xs={12} md={6}>
                                    <Grid container alignItems="center" spacing={1}>
                                        <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                            <InputLabel id="matchingOptions">Matching:</InputLabel>
                                        </Grid>
                                        <Grid item xs>
                                            <FormControl fullWidth>
                                                <Select
                                                    labelId="matchingOptions"
                                                    id="matchingOptions"
                                                    name="matchingOptions"
                                                    value={formData.matchingOptions}
                                                    onChange={(e) => handleDropdownChange(e, 'matchingOptions')}
                                                    sx={inputStyles}
                                                >
                                                    <MenuItem value="">Select an option</MenuItem>
                                                    <MenuItem value="yes">Yes</MenuItem>
                                                    <MenuItem value="no">No</MenuItem>
                                                </Select>
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </Grid>
                                {formData.matchingOptions === 'yes' && (
                                    <Grid item xs={12} md={6}>
                                        <Grid container alignItems="center" spacing={1}>
                                            <Grid item style={isDesktop ? { width: '30%' } : { width: '100%' }}>
                                                <InputLabel id="numberOfMatching">No. of Matching:</InputLabel>
                                            </Grid>
                                            <Grid item xs>
                                                <FormControl fullWidth>
                                                    <Select
                                                        labelId="numberOfMatching"
                                                        id="numberOfMatching"
                                                        name="numberOfMatching"
                                                        value={formData.numberOfMatching}
                                                        onChange={handleNumberOfMatchingChange}
                                                        sx={inputStyles}
                                                    >
                                                        {[0, 1, 2, 3].map((item, index) => (
                                                            <MenuItem key={index} value={item}>{item}</MenuItem>
                                                        ))}
                                                    </Select>
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                )}
                            </Grid>

                            <Grid item xs={6} textAlign="center" sx={{ mt: 1 }}>
                                <Button variant="contained" color="primary" onClick={handleNavigatePanna}>New Panna</Button>
                            </Grid>

                            <div style={{ marginTop: '1%' }}>
                                <TableContainer>
                                    <Table>
                                        <TableHead>
                                            <TableRow>
                                                <TableCell className='th4' sx={{ p: 1, border: '1px solid #000' }}>Size &#8594;</TableCell>
                                                {sizes.map((size) => (
                                                    <TableCell key={size} className='th4' sx={{ p: 1, border: '1px solid #000' }} colSpan={1 + (formData.matchingOptions === 'yes' ? formData.numberOfMatching : 0)} align='center'>{size}</TableCell>
                                                ))}
                                            </TableRow>
                                            <TableRow>
                                                <TableCell className='th4' sx={{ p: 1, border: '1px solid #000' }}>Panna</TableCell>
                                                {sizes.map((size) => (
                                                    <React.Fragment key={size}>
                                                        <TableCell className='th4' sx={{ p: 1, border: '1px solid #000' }}>Main</TableCell>
                                                        {
                                                            formData.matchingOptions === 'yes' ?
                                                                (
                                                                    [...Array(formData.numberOfMatching).keys()].map((index) => (
                                                                        <TableCell key={index + 1} className='th4' sx={{ p: 1, border: '1px solid #000' }}>M-{index + 1}</TableCell>
                                                                    ))
                                                                ) :
                                                                (null)
                                                        }
                                                    </React.Fragment>

                                                ))}
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {pannaValues?.map((panna) => (
                                                <TableRow key={panna}>
                                                    <TableCell sx={{ p: 1, border: '1px solid #000' }}>{panna}</TableCell>
                                                    {sizes.map((size) => {
                                                        return (
                                                            <React.Fragment key={size}>
                                                                <TableCell sx={{ p: 1, border: '1px solid #000' }}>
                                                                    <TextField
                                                                        type="text"
                                                                        value={inputValues[`${size}|${panna}|Main`] || ''}
                                                                        onChange={(e) =>
                                                                            handleInputChange(size, panna, e.target.value)
                                                                        }
                                                                        style={{ width: '40px' }}
                                                                        inputProps={{ style: styled.inputs }}
                                                                        placeholder='0'
                                                                        variant="outlined"
                                                                        size="small"
                                                                    />
                                                                </TableCell>
                                                                {formData.matchingOptions === 'yes' && (
                                                                    renderMatchingInputs(size, panna)
                                                                )}
                                                            </React.Fragment>
                                                        );
                                                    })}
                                                </TableRow>
                                            ))}
                                        </TableBody>
                                    </Table>
                                </TableContainer>
                            </div>
                            <Grid item xs={12} textAlign="center" sx={{ mt: 1 }}>
                                <Button variant="contained" color="primary" onClick={handleSubmit}>Submit</Button>
                            </Grid>
                        </Paper>
                        <ToastContainer />
                    </Grid>
                </Grid>

            </div>
        </>
    );
}
export default NewItemAvgEntry;